/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  BadRequestResponse,
  CreateCheckoutSession200,
  ForbiddenResponse,
  GetBillingUsage200,
  GetBillingUsageParams,
  InternalServerErrorResponse,
  NotFoundResponse,
  UnauthorizedResponse
} from '.././model'
import { customInstance } from '../../custom-instance';


// eslint-disable-next-line
  type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;


/**
 * @summary Retrieve billing usage for an organization
 */
export const getBillingUsage = (
    organizationId: string,
    params: GetBillingUsageParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetBillingUsage200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/billing/usage`, method: 'get',
        params, signal
    },
      options);
    }
  

export const getGetBillingUsageQueryKey = (organizationId: string,
    params: GetBillingUsageParams,) => {
    
    return [`https://api.app.usesky.ai/organizations/${organizationId}/billing/usage`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBillingUsageQueryOptions = <TData = Awaited<ReturnType<typeof getBillingUsage>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    params: GetBillingUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingUsage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingUsageQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingUsage>>> = ({ signal }) => getBillingUsage(organizationId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingUsage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBillingUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingUsage>>>
export type GetBillingUsageQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

/**
 * @summary Retrieve billing usage for an organization
 */
export const useGetBillingUsage = <TData = Awaited<ReturnType<typeof getBillingUsage>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params: GetBillingUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingUsage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBillingUsageQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Create a checkout session for billing
 */
export const createCheckoutSession = (
    organizationId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CreateCheckoutSession200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/billing/checkout-session`, method: 'post'
    },
      options);
    }
  


export const getCreateCheckoutSessionMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCheckoutSession>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCheckoutSession>>, TError,{organizationId: string}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCheckoutSession>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  createCheckoutSession(organizationId,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateCheckoutSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createCheckoutSession>>>
    
    export type CreateCheckoutSessionMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Create a checkout session for billing
 */
export const useCreateCheckoutSession = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCheckoutSession>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getCreateCheckoutSessionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    